<template>
  <!--
    	作者：gmshop
    	时间：2019-10-26
    	描述：商品管理-商品添加
    -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="180px">
      <!--基础信息-->
      <Basic></Basic>

      <!--规格设置-->
      <Spec></Spec>

      <!--商品详情-->
      <Content></Content>

      <!--商品活动-->
      <Activity></Activity>

      <!--高级设置-->
      <Buyset></Buyset>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">发布</el-button>
        <el-button size="small" type="primary" @click="Draft" :loading="loading">保存为草稿</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import PorductApi from '@/api/product.js';
import Basic from './part/Basic.vue';
import Spec from './part/Spec.vue';
import Content from './part/Content.vue';
import Activity from './part/Activity.vue';
import Buyset from './part/Buyset.vue';
export default {
  components: {
    /*基础信息*/
    Basic,
    /*规格信息*/
    Spec,
    /*商品详情*/
    Content,
    /*高级设置*/
    Buyset,
    /*活动设置*/
    Activity,
  },
  data() {
    return {
      /*是否正在加载*/
      loading: false,
      /*form表单数据*/
      form: {
        model: {
          /*商品名称*/
          product_name:'',
          /*商品编码*/
          product_no:'',
          /*商品分类*/
          category_id: null,
          /*商品图片*/
          image: [],
          /*商品卖点*/
          selling_point:'',
          /*分销类型*/
          commission_type:0,
          /*规格类别,默认10单规格，20多规格*/
          spec_type: 10,
          /*库存计算方式,默认20付款减库存，10下单减库存*/
          deduct_stock_type: 20,
          /*检查用户等级*/
          is_alone_grade: 0,
          /*活动类型 0 视频 1 活动 2普通*/
          is_line:0,
          /*是否关联课程 0 否 1 是*/
          is_course:1,
          /*活动数据*/
          active:{
            active_time:'',
            name:'',
            address:'',
            mobile:'',
            dec:'',
            number:1,
            coordinate:'',
          },
          /*课程*/
          course:'',
          sku: {},
          /*多规格类别*/
          spec_many: {
            /*多规格类别*/
            spec_attr: [],
            /*多规格表格数据*/
            spec_list: []
          },
          /*商品购买权限,默认为关闭 0 开启为1*/
          buy_limit: 0,
          /*购买权限详情*/
          buy_auth:[],
          /*商品详情内容*/
          content: '',
          /*运费模板ID*/
          delivery_id: '',
          /*商品状态*/
          product_status: 10,
          /*初始销量*/
          sales_initial: 0,
          /*商品排序，默认100*/
          product_sort: 100,
          /*是否开启积分赠送,默认1为开启，0为关闭*/
          is_points_gift: 0,
          /*是否允许使用积分抵扣,默认1为允许，0为不允许*/
          is_points_discount: 0,
          /*会员折扣设置,默认1为单独设置折扣,0为默认折扣*/
          is_enable_grade: 1,
          /*等级金额类型,默认10为百分比，20为固定金额*/
          alone_grade_type: 10,
          /*是否开启单独分销,默认0为关闭，1为开启*/
          is_ind_agent: 0,
          /*分销类型 0 统一 1 按等级*/
          commission_type:0,
          /*分销佣金类型,默认10为百分比，20为固定金额*/
          agent_money_type: 10,
          /*积分抵扣类型,默认10为百分比，20为固定金额*/
          alone_credit_type:10,
          /*一级佣金*/
          first_money:0,
          /*二级佣金*/
          second_money:0,
          /*三级佣金*/
          third_money:0,
          /*代理极差设置,默认0为关闭，1为开启*/
          is_alone_enable_grade_equity:0,
          /*是否虚拟商品*/
          is_virtual: 0,
          /*升级的等级*/
          up_grade_id: '',
          supplier_id: '',
          /*单次限购数量*/
          buy_limit_num: 0,
          /*累计限购数量*/
          buy_total_num: 0,
          /*积分抵扣*/
          points_discount: 0,
          label_id: [],//标签集合
          is_recommend: false,  //推荐
          is_hot: false, // 热卖
          is_new: false, //新品
          poster: '',//视频封面
          video: '',//视频
          skucate:[],// sku 分类
        },
        /*商品分类*/
        catgory: [],
        /*标签*/
        label: [],
        /*运费模板*/
        delivery: [],
        /*会员等级*/
        gradeList: [],
        supplierList: [],
        /*规格数据*/
        specData: null,
        /*是否锁住*/
        isSpecLocked: false,
        /*是否锁住活动类型*/
        isTypeLocked: false,
        /*分销基础设置*/
        basicSetting: {},
      }
    };
  },
  provide: function () {
    return {
      form: this.form
    }
  },
  created() {

    /*获取基础数据*/
    this.getBaseData();

  },
  methods: {

    /*获取基础数据*/
    getBaseData: function() {
      let self = this;
      PorductApi.getBaseData({}, true)
        .then(res => {
          self.loading = false;
          Object.assign(self.form, res.data);
          self.form.gradeList.forEach(item=>{
            self.$set(item, 'first_money', 0)
            self.$set(item, 'second_money', 0)
            self.$set(item, 'third_money',0)
            self.$set(item, 'push',0)
          });
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*转JSON字符串*/
    convertJson(list){
      let obj={};
      list.forEach(item=>{
        obj[item.grade_id]=item.product_equity;
      });
      return JSON.stringify(obj);
    },
    /*转JSON字符串*/
    convertMoneyJson(list){
      let obj={};
      let obj1={};
      let obj2={};
      let arr ={};
      list.forEach(item=>{
        obj[item.grade_id]=item.first_money;
        obj1[item.grade_id]=item.second_money;
        obj2[item.grade_id]=item.third_money;
      });
      arr['first_money'] = obj;
      arr['second_money'] = obj1;
      arr['third_money'] = obj2;
      return JSON.stringify(arr);
    },
    /*转JSON字符串*/
    convertEnableJson(list){
      let obj={};
      list.forEach(item=>{
        obj[item.grade_id]=item.push;
      });
      return JSON.stringify(obj);
    },
    /*提交*/
    onSubmit: function() {
      let self = this;
      let params = self.form.model;
      params.is_hot = self.form.model.is_hot ? 1: 0;
      params.is_recommend = self.form.model.is_recommend ? 1: 0;
      params.is_new = self.form.model.is_new ? 1: 0;
      if(params.is_line ==2){
        if(!params.course){
          self.$message({
            message: '请选择关联课程',
            type: 'error'
          });
          return;
        }
      }
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          params.active =JSON.stringify(params.active);
          params.alone_grade_equity=self.convertJson(self.form.gradeList);
          params.alone_money_equity=self.convertMoneyJson(self.form.gradeList);
          params.alone_enable_grade_equity=self.convertEnableJson(self.form.gradeList);
          PorductApi.addProduct({
            params: JSON.stringify(params)
          }, true)
            .then(data => {
              self.loading = false;
              self.$message({ 
                message: '添加成功',
                type: 'success'
              });
              self.$router.push('/product/product/index');
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*保存为草稿*/
    Draft() {
      let self = this;
      self.form.model.product_status = 30;
      self.onSubmit();
    },

    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    }

  }
};
</script>

<style lang="scss" scoped>
.basic-setting-content {
}

.product-add {
  padding-bottom: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/product/product/add.vue